import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Navigation, Footer } from "@/components/navigation";
import { SlotInjector } from "@/components/slots";
import { DegradedServiceBanner } from "@/components/DegradedServiceBanner";
import { useReferralTracking } from "@/hooks/useReferralTracking";

/**
 * Main layout component matching the old longitude-elite structure
 */
export const PageLoading = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );
};

export const Layout = () => {
  useReferralTracking();

  return (
    <div className="min-h-screen flex flex-col overflow-x-clip">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-white focus:text-tenant-primary focus:rounded focus:shadow-lg focus:outline-2 focus:outline-tenant-primary"
      >
        Skip to main content
      </a>

      {/* Dynamic announcement bar slot */}
      <SlotInjector position="announcement" />
      <DegradedServiceBanner />

      {/* Navigation */}
      <Navigation />

      {/* Dynamic hero slot (for homepage banners, etc.) */}
      <SlotInjector position="hero" />

      {/* Dynamic above-content slot */}
      <SlotInjector position="above-content" />

      {/* Main content */}
      <main id="main-content" className="flex-1 w-full">
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </main>

      {/* Dynamic below-content slot */}
      <SlotInjector position="below-content" />

      {/* Dynamic above-footer slot */}
      <SlotInjector position="above-footer" />

      {/* Footer */}
      <Footer />
    </div>
  );
};
